import {useCallback} from "react";
import {apiEndpoint, useUser} from "@/components/Providers/JWTProvider.tsx";

const useGetTaxYears = (): (() => Promise<Response | void>) => {
    const {user} = useUser();

    return useCallback(async (): Promise<Response | void> => {
        const url = new URL("/v1/tax-statement/years", apiEndpoint);

        if (!user) {
            console.error("Failed to fetch available years: user not found");
            return;
        }

        if (!("apiFetch" in user)) {
            console.error("Failed to fetch available years: apiFetch not available");
            return;
        }

        return await user.apiFetch(url.toString(), {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
    }, [user]);
};

export default useGetTaxYears;
